// @ts-strict-ignore
import {Component, Input, output} from "@angular/core";
import {FormArray, FormControl} from "@angular/forms";
import {Checklist} from "@models";
import {SimChecklistService} from "@services";
import {VMAutoCompleteNormal} from "../sim-base-chip-input/sim-base-chip-input.component";

@Component({
	selector: "sim-checklist-chip-input",
	templateUrl: "./sim-checklist-chip-input.component.html",
	styleUrls: ["./sim-checklist-chip-input.component.scss"],
	standalone: false,
})
export class SimChecklistChipInputComponent {
	@Input() checklistFc: FormArray<FormControl<Checklist>>;
	@Input() label: string;
	@Input() placeholder: string;
	@Input() isDisabled = false;

	@Input() canSelectMultipleChecklists = false;

	optionSelected = output<Checklist>();

	autoCompleteData: VMAutoCompleteNormal<Checklist>[] = [];

	constructor(private _simChecklistService: SimChecklistService) {}

	reloadAutoCompleteData(searchString: string) {
		this._simChecklistService.listChecklists(searchString, "Name", true, 0, 20).then((checklists) => {
			this.autoCompleteData = checklists.data.map((c) => ({
				displayName: c.name,
				value: c,
			}));
		});
	}
}
